import script from "./drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer.vue?vue&type=script&setup=true&lang=js"

import "./drawer.vue?vue&type=style&index=0&id=5b060eea&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_385237cdc31ad6fed45be0dc27322b77/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b060eea"]])

export default __exports__